<template>
  <div class="info d-flex flex-column">
    <h2>{{ $t('account.profile') }}</h2>

    <nav>
      <router-link :to='{ "name": "profile.info.info-change" }'>
        {{ $t('account.personal') }}
      </router-link>

      <router-link v-if="patient.primary_patient" :to='{ "name": "profile.info.password-change" }'>
        {{ $t('account.password_change') }}

      </router-link>
      <router-link v-if="patient.balances.length > 0" :to='{ "name": "profile.info.balance" }'>
        {{ $t('account.balance') }}

      </router-link>
    </nav>

    <router-view></router-view>
  </div>
</template>

<script>
import {mapGetters} from "vuex";

export default {
  name: 'info',
  computed: {
    ...mapGetters([
      'patient'
    ])
  },
}
</script>

<style lang="scss">
.info {
  & > h2 {
    margin-top: 25px;
    font-size: 42px;
    color: #0a4766;
  }

  & > nav {
    margin-top: 35px;

    & > * {
      padding-bottom: 5px;
      font-size: 18px;
      color: #0084b6;

      &:hover, &.router-link-active {
        text-decoration: none;
        color: #0a4766;
        border-bottom: 2px solid #b0e645;
      }
    }

    & > *:not(:first-child) {
      margin-left: 30px;
    }
  }
}
</style>
